import { Action, Module, Mutation } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import {
  queryDataDictionaryListLang,
  queryCustomOrderPages
} from "@/graphql/order.gql";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { GTGroupFixedOrgParam } from "@/enums/app";
import { getValueFromPromiseArray } from "@/utils/common";
import { formatProductData } from "@/utils/mall/mall";
import type { PaginationDataState } from "@/types";

export interface MallOrderListState extends PaginationDataState {
  tabData: any[];
  listData: any[];
  selectedTab: string[];
}

@Module({ name: "MallOrderListModule", namespaced: true })
export default class MallOrderListModule
  extends PaginationModule<MallOrderListState, RootState>
  implements MallOrderListState {
  public tabData = [];
  public listData = [];
  public selectedTab = [];

  @Mutation
  saveTabsDataMutation(data: any[]) {
    this.tabData = data || [];
  }
  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }
  @Mutation
  saveSelectedTabMutation(data: any[]) {
    this.selectedTab = data || [];
  }

  // 状态 tabs
  @Action
  async initTabDataAction() {
    const tabData = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: { input: { ddCode: "ORDER_STATUS_21" } }
    });
    const { commit } = this.context;
    commit("saveTabsDataMutation", tabData);
  }

  // 订单列表
  @Action
  async initListAction() {
    let {
      state: {
        selectedTab,
        paginationData: { pageNum, pageSize }
      }
    } = this.context;
    const {
      dataList = [],
      pageInfo: { totalCount }
    } = await queryRequest({
      query: queryCustomOrderPages,
      variables: {
        customOrderQueryInput: {
          orderStatus: selectedTab.join(","),
          orderType: "11",
          channelCode: "WT"
          // ...GTGroupFixedOrgParam
        },
        pageInput: { pageNum, pageSize }
      }
    });
    let {
      commit,
      state: { paginationData }
    } = this.context;

    let allData = await this.formatListDataAction(
      dataList.map(item => item.data).filter(Boolean)
    );
    commit(
      paginationData.pageNum === 1
        ? "saveListDataMutation"
        : "addListDataMutation",
      allData
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  // 初始化数据，格式化属性名
  @Action
  async formatListDataAction(data: any[]) {
    let result: any = data.map(item => {
      item.orderProductOutList = item.orderProductOutList.map(sku =>
        formatProductData(sku)
      );
      return item;
    });
    return result;
  }
}
